export const osUtils = {
    methods: {
        isMobile () {
            return !!(window.matchMedia("(max-width: 767px)").matches)
        }
    }
}